import { type SizeGridItem } from '@trwl/backend.api';
import cn from 'classnames';
import { forwardRef, HTMLAttributes, useMemo } from 'react';

const SIZE_DELIMITER = ',';

interface ISizeGridProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  sizeGrid: SizeGridItem[];
}

export const SizeGrid = forwardRef<HTMLDivElement, ISizeGridProps>(
  ({ sizeGrid, title = 'Таблица размеров', ...other }, ref) => {
    const uniqueSizeGrid = useMemo(() => {
      const result: SizeGridItem[] = [];
      const keys = new Set<string>();

      sizeGrid.forEach((sizeGridItem) => {
        if (!keys.has(sizeGridItem.key)) {
          result.push(sizeGridItem);
        }
        keys.add(sizeGridItem.key);
      });
      return result;
    }, [sizeGrid]);

    if (sizeGrid.length === 0) return null;

    return (
      <div {...other} className={cn('w-full', other.className)}>
        <div className={'text-[#282828] text-[20px] font-[500]'}>{title}</div>
        <div
          ref={ref}
          className="mt-[10px] flex flex-nowrap w-full items-stretch content-center flex-row justify-start"
        >
          <div>
            <table>
              <thead>
                {uniqueSizeGrid.map((sizeGridItem: SizeGridItem) => (
                  <tr key={'sizeKey-'.concat(sizeGridItem.key)}>
                    <th
                      className={cn(
                        'py-2 px-3 text-center whitespace-nowrap border border-gray-200 bg-primary text-white font-normal',
                      )}
                    >
                      {sizeGridItem.key}
                    </th>
                  </tr>
                ))}
              </thead>
            </table>
          </div>
          <div className="overflow-scroll w-full">
            <table className="w-full border-collapse">
              <tbody>
                {uniqueSizeGrid.map((sizeGridItem: SizeGridItem) => (
                  <tr key={'sizeValue-'.concat(sizeGridItem.key)}>
                    {sizeGridItem.value
                      .split(SIZE_DELIMITER)
                      .map((value, index) => (
                        <td
                          key={value.concat(`-${index}`)}
                          className={cn(
                            'p-2 text-center whitespace-nowrap border border-gray-200 font-normal',
                          )}
                        >
                          {value}
                        </td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  },
);

SizeGrid.displayName = 'SizeGrid';
